import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useEffect } from 'react';
import { INPROGRESS, GENERAL_MAINTENANCE, formateMessage, MODULE_MAINTENANCE } from '../helper/index.js';
import { useGetMaintenanceNotice } from '../services/index.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const emptyValue = {
  maintenanceType: "",
  title: "Maintenance Notice",
  message: "",
  startTime: "",
  endTime: "",
  landingPage: true,
  homePage: true,
  navigate: () => null,
  isFeatureUnderMaintenance: () => false,
  maintenanceData: null
};
const MaintenanceContext = createContext(emptyValue);
MaintenanceContext.displayName = "MaintenanceContext";
const MaintenanceProvider = _ref => {
  let {
    children,
    navigate,
    maintenanceDataURL,
    disableMaintenanceModal = false
  } = _ref;
  const [data, setData] = useState(emptyValue);
  const {
    data: maintenanceData,
    refetch
  } = useGetMaintenanceNotice(maintenanceDataURL);
  useEffect(() => {
    refetch();
    const maintenanceInterval = setInterval(() => setMaintenanceTime(), 6e4);
    return () => {
      clearInterval(maintenanceInterval);
    };
  }, []);
  useEffect(() => {
    if (maintenanceData) {
      setData(prevState => __spreadProps(__spreadValues({}, prevState), {
        maintenanceData
      }));
      setMaintenanceTime();
    } else {
      setData(emptyValue);
    }
  }, [maintenanceData]);
  const checkFeatureUnderMaintenance = featureId => {
    var _a;
    try {
      if ((maintenanceData == null ? void 0 : maintenanceData.notificationType) === MODULE_MAINTENANCE && (maintenanceData == null ? void 0 : maintenanceData.notificationStatus) === INPROGRESS && ((_a = maintenanceData == null ? void 0 : maintenanceData.maintenanceModuleList) == null ? void 0 : _a.length) && (featureId == null ? void 0 : featureId.length) && !disableMaintenanceModal) {
        const now = /* @__PURE__ */new Date();
        if (now >= new Date(maintenanceData.downtimeStartDate) && now < new Date(maintenanceData.downtimeEndDate) && maintenanceData.maintenanceModuleList.some(item => item.featureCode === featureId || item.featureName === featureId)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };
  const setMaintenanceTime = () => {
    var _a;
    try {
      if ((_a = maintenanceData == null ? void 0 : maintenanceData.dateRange) == null ? void 0 : _a.length) {
        const dateRange = maintenanceData.dateRange[0];
        const startDate = (maintenanceData == null ? void 0 : maintenanceData.notificationStatus) === INPROGRESS ? maintenanceData.downtimeStartDate : dateRange.notifyStartDate;
        const endDate = (maintenanceData == null ? void 0 : maintenanceData.notificationStatus) === INPROGRESS ? maintenanceData.downtimeEndDate : dateRange.notifyEndDate;
        const now = /* @__PURE__ */new Date();
        const messageContent = (maintenanceData == null ? void 0 : maintenanceData.notificationStatus) === INPROGRESS ? maintenanceData.downtimeMsg : maintenanceData.message;
        if (now >= new Date(startDate) && now < new Date(endDate)) {
          if (maintenanceData.landingPage || maintenanceData.homePage || maintenanceData.notificationType === GENERAL_MAINTENANCE) {
            const message = formateMessage(messageContent, maintenanceData.downtimeStartDate, maintenanceData.downtimeEndDate);
            setData(prevState => __spreadProps(__spreadValues({}, prevState), {
              title: maintenanceData.notificationType === GENERAL_MAINTENANCE ? "Notice" : "Maintenance Notice",
              message,
              startTime: maintenanceData.downtimeStartDate,
              endTime: maintenanceData.downtimeEndDate,
              landingPage: maintenanceData.notificationType === GENERAL_MAINTENANCE ? true : maintenanceData.landingPage,
              homePage: maintenanceData.notificationType === GENERAL_MAINTENANCE ? true : maintenanceData.homePage,
              maintenanceType: maintenanceData.notificationType,
              navigate,
              isFeatureUnderMaintenance: checkFeatureUnderMaintenance
            }));
          }
        } else {
          setData(emptyValue);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  return /* @__PURE__ */jsx(MaintenanceContext.Provider, {
    value: data,
    children
  });
};
export { MaintenanceContext, MaintenanceProvider };